import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=52db1701&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=ts"
export * from "./GroupTable.vue?vue&type=script&lang=ts"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=52db1701&prod&lang=scss&scoped=true"
import style1 from "./GroupTable.vue?vue&type=style&index=1&id=52db1701&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db1701",
  null
  
)

export default component.exports